// 🚨 Auto-generated file. Do not edit manually.

export const blogImages = {
  '5BenefitsOfCeramicCoatingsInfographic': {
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1744488932/mad-web-app/blog-images/5-benefits-of-ceramic-coatings-infographic.webp',
    publicId:
      'mad-web-app/blog-images/5-benefits-of-ceramic-coatings-infographic',
    alt: '5 Benefits Of Ceramic Coatings Infographic Blog Image',
  },
  winterCarDetailing10EssentialTips: {
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1744488931/mad-web-app/blog-images/winter-car-detailing-10-essential-tips.webp',
    publicId: 'mad-web-app/blog-images/winter-car-detailing-10-essential-tips',
    alt: 'Winter Car Detailing 10 Essential Tips Blog Image',
  },
  getYourCarReadyForFallEssentialTipsFromMayesAutoDetailing: {
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1744488931/mad-web-app/blog-images/get-your-car-ready-for-fall-essential-tips-from-mayes-auto-detailing.webp',
    publicId:
      'mad-web-app/blog-images/get-your-car-ready-for-fall-essential-tips-from-mayes-auto-detailing',
    alt: 'Get Your Car Ready For Fall Essential Tips From {business.name} Blog Image',
  },
  totalInteriorShampooChattanooga: {
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1744488930/mad-web-app/blog-images/total-interior-shampoo-{business.address.city}.jpg',
    publicId:
      'mad-web-app/blog-images/total-interior-shampoo-{business.address.city}',
    alt: 'Total Interior Shampoo {business.address.city} Blog Image',
  },
  whyVehicleTintingIsAGreatInvestmentInYourCar: {
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1744488929/mad-web-app/blog-images/why-vehicle-tinting-is-a-great-investment-in-your-car.webp',
    publicId:
      'mad-web-app/blog-images/why-vehicle-tinting-is-a-great-investment-in-your-car',
    alt: 'Why Vehicle Tinting Is A Great Investment In Your Car Blog Image',
  },
  autoDetailingHowOftenShouldIDeepCleanMyCar: {
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1744488928/mad-web-app/blog-images/auto-detailing-how-often-should-i-deep-clean-my-car.webp',
    publicId:
      'mad-web-app/blog-images/auto-detailing-how-often-should-i-deep-clean-my-car',
    alt: 'Auto Detailing How Often Should I Deep Clean My Car Blog Image',
  },
  choosingTheRightCarDetailer: {
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1744488927/mad-web-app/blog-images/choosing-the-right-car-detailer.jpg',
    publicId: 'mad-web-app/blog-images/choosing-the-right-car-detailer',
    alt: 'Choosing The Right Car Detailer Blog Image',
  },
  welcomingSolarfxWindowFilm: {
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1744488926/mad-web-app/blog-images/welcoming-solarfx-window-film.webp',
    publicId: 'mad-web-app/blog-images/welcoming-solarfx-window-film',
    alt: 'Welcoming Solarfx Window Film Blog Image',
  },
  unveilingTheBrillianceWhatIsCeramicCoating: {
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1744488925/mad-web-app/blog-images/unveiling-the-brilliance-what-is-ceramic-coating.webp',
    publicId:
      'mad-web-app/blog-images/unveiling-the-brilliance-what-is-ceramic-coating',
    alt: 'Unveiling The Brilliance What Is Ceramic Coating Blog Image',
  },
  ourNewWebsiteIsLive: {
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1744488924/mad-web-app/blog-images/our-new-website-is-live.webp',
    publicId: 'mad-web-app/blog-images/our-new-website-is-live',
    alt: 'Our New Website Is Live Blog Image',
  },
  welcomingTeslaToChattanooga: {
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1744488923/mad-web-app/blog-images/welcoming-tesla-to-{business.address.city}.webp',
    publicId:
      'mad-web-app/blog-images/welcoming-tesla-to-{business.address.city}',
    alt: 'Welcoming Tesla To {business.address.city} Blog Image',
  },
  windowTintAndElectricVehiclesWhatYouShouldKnow: {
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1744488922/mad-web-app/blog-images/window-tint-and-electric-vehicles-what-you-should-know.webp',
    publicId:
      'mad-web-app/blog-images/window-tint-and-electric-vehicles-what-you-should-know',
    alt: 'Window Tint And Electric Vehicles What You Should Know Blog Image',
  },
  carInterior10TipsForEffortlessMaintenance: {
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1744488921/mad-web-app/blog-images/car-interior-10-tips-for-effortless-maintenance.webp',
    publicId:
      'mad-web-app/blog-images/car-interior-10-tips-for-effortless-maintenance',
    alt: 'Car Interior 10 Tips For Effortless Maintenance Blog Image',
  },
  springCarPrepGuide: {
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1744488921/mad-web-app/blog-images/spring-car-prep-guide.webp',
    publicId: 'mad-web-app/blog-images/spring-car-prep-guide',
    alt: 'Spring Car Prep Guide Blog Image',
  },
  whyDoINeedCeramicCoating: {
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1744488920/mad-web-app/blog-images/why-do-i-need-ceramic-coating.webp',
    publicId: 'mad-web-app/blog-images/why-do-i-need-ceramic-coating',
    alt: 'Why Do I Need Ceramic Coating Blog Image',
  },
  theEmbassyCarCareGiftCardsThePerfectGiftForAnyOccasion: {
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1744488919/mad-web-app/blog-images/the-embassy-car-care-gift-cards-the-perfect-gift-for-any-occasion.webp',
    publicId:
      'mad-web-app/blog-images/the-embassy-car-care-gift-cards-the-perfect-gift-for-any-occasion',
    alt: 'The Embassy Car Care Gift Cards The Perfect Gift For Any Occasion Blog Image',
  },
};
